import { StateUtils } from '@spartacus/core';
import { ReelCutting } from '../../../../../core/model';
import { CartEntryReelCuttingActionTypes } from '../actions/cart-entry-reel-cutting.action';
import { CartActions } from '../actions/index';

export const initialState: ReelCutting = undefined;

export function reducer(
  state = initialState,
  action: CartActions.CartEntryReelCuttingActions | StateUtils.LoaderAction
): ReelCutting {
  switch (action.type) {
    case CartEntryReelCuttingActionTypes.CalculateReelCuttingPriceFail: {
      return initialState;
    }
    case CartEntryReelCuttingActionTypes.CalculateReelCuttingPriceSuccess: {
      return action.payload ? action.payload.result : initialState;
    }
  }
  return state;
}
